<!-- page starts-->
<section class="page-wrapper">
	<div class="checkout-top-section">
		<div class="container">
			<div class="checkout-top-detail cf">
				<div class="checkout-top-detail-inner">
					<div class="checkout-top-detail-content">
						<p>A Northern Premier League match at Hurst Cross Stadium</p>
					</div>
					<div class="checkout-top-detail-team cf">
						<div class="checkout-top-detail-team-left">
							<div class="checkout-top-detail-team-left-content">
								<div class="checkout-top-detail-team-left-content-inner">
									<h3>{{matchticketSingle?.title}}</h3>
								</div>
							</div>
							<div class="checkout-top-detail-team-left-image">
								<img [src]="matchticketSingle?.first_image">
							</div>
						</div>
						<div class="checkout-top-detail-team-center">
							<div class="checkout-top-detail-team-center-inner">
								<h3>Home {{matchticketSingle?.date_time | amDateFormat:'H:mm'}}</h3>
								<p>{{matchticketSingle?.date_time | amDateFormat:'ddd D MMM YYYY'}}</p>
							</div>
						</div>
						<div class="checkout-top-detail-team-right">
							<div class="checkout-top-detail-team-left-image">
								<img [src]="matchticketSingle?.second_team">
							</div>
							<div class="checkout-top-detail-team-left-content">
								<div class="checkout-top-detail-team-left-content-inner">
									<h3>Radcliffe Borough</h3>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="checkout-center-section cf">
		<div class="container">
			<div class="checkout-center-detail cf">
				<div class="checkout-center-detail-left">
					<div class="general-admission-box">
						<table border="0" cellspacing="0" cellpadding="0">
							<tr class="red-bg">
								<th>General Admission</th>
								<th>Price</th>
								<th>Amount</th>
							</tr>
							<tr *ngFor="let price of matchticketSingle?.matchticket_general">
								<td>
									<p><span class="images"><img src="assets/images/adult-ic.svg"></span><span
											class="name">{{price?.title}}</span></p>
								</td>
								<td>£{{price?.amount}}.00</td>
								<td>
									<div class="select-box">
										<div class="product-quantity">
											<div class="product-quantity-box">
												<input data-min="0" id="quantity{{price?.matchticket_detail_id}}"
													name="quantity" readonly="true" type="text" value="0">
												<input data-min="0" hidden id="price{{price?.matchticket_detail_id}}"
													name="price" readonly="true" type="text" value="{{price?.amount}}">
												<div class="quantity-selectors-container">
													<div class="quantity-selectors">
														<button id="{{price?.matchticket_detail_id}}"
															class="increment-quantity" type="button"
															aria-label="Add one"
															data-direction="1"><span>+</span></button>
														<button class="decrement-quantity"
															data-id="{{price?.matchticket_detail_id}}"
															id="{{price?.matchticket_detail_id}}" type="button"
															aria-label="Subtract one"
															data-direction="-1"><span>−</span></button>
													</div>
												</div>
											</div>
										</div>
									</div>
								</td>
							</tr>
						</table>
					</div>
					<div class="away-fans">
						<table border="0" cellspacing="0" cellpadding="0">
							<tr class="red-bg">
								<th>Away Fans</th>
								<th>Price</th>
								<th>Amount</th>
							</tr>
							<tr *ngFor="let away of matchticketSingle?.matchticket_away">
								<td>
									<p><span class="images"><img src="assets/images/adult-ic.svg"></span><span
											class="name">{{away?.title}}</span></p>
								</td>
								<td>£{{away?.amount}}.00</td>
								<td>
									<div class="select-box">
										<div class="product-quantity">
											<div class="product-quantity-box">
												<input data-min="0" id="quantity{{away?.matchticket_detail_id}}"
													name="quantity" readonly="true" type="text" value="0">
												<input data-min="0" hidden id="price{{away?.matchticket_detail_id}}"
													name="price" readonly="true" type="text" value="{{away?.amount}}">
												<div class="quantity-selectors-container">
													<div class="quantity-selectors">
														<button id="{{away?.matchticket_detail_id}}" class="increment-quantity" type="button" aria-label="Add one" data-direction="1"><span>+</span></button>
														<button class="decrement-quantity" data-id="{{away?.matchticket_detail_id}}" id="{{away?.matchticket_detail_id}}" type="button" aria-label="Subtract one" data-direction="-1"><span>−</span></button>
													</div>
												</div>
											</div>
										</div>
									</div>
								</td>
							</tr>

						</table>
					</div>
				</div>
				<div class="checkout-center-detail-right" *ngIf="matchticketSingle">
					<h2>Bookings Summary</h2>
					<div class="checkout-center-detail-right-general-admission">
						<h3>General Admission </h3>
						<div class="checkout-center-detail-right-general-admission-detail cf">
							<div class="checkout-center-detail-right-general-admission-name">
								<p>Adult</p>
								<p>Senior (Over 65)</p>
								<p>Student</p>
								<p>Child (Under 12)</p>
							</div>
							<div class="checkout-center-detail-right-general-admission-number">
								<p id="pNos1">0 Nos.</p>
								<p id="pNos2">0 Nos.</p>
								<p id="pNos3">0 Nos.</p>
								<p id="pNos4">0 Nos.</p>
							</div>
							<div class="checkout-center-detail-right-general-admission-price">
								<p id="pPrice1">£00.00</p>
								<p id="pPrice2">£00.00</p>
								<p id="pPrice3">£00.00</p>
								<p id="pPrice4">£00.00</p>
							</div>
						</div>
						<h3>Away</h3>
						<div class="checkout-center-detail-right-general-admission-detail cf">
							<div class="checkout-center-detail-right-general-admission-name">
								<p>Adult</p>
								<p>Senior (Over 65)</p>
								<p>Student</p>
								<p>Child (Under 12)</p>
							</div>
							<div class="checkout-center-detail-right-general-admission-number">
								<p id="pNos1">0 Nos.</p>
								<p id="pNos2">0 Nos.</p>
								<p id="pNos3">0 Nos.</p>
								<p id="pNos4">0 Nos.</p>
							</div>
							<div class="checkout-center-detail-right-general-admission-price">
								<p id="pPrice1">£00.00</p>
								<p id="pPrice2">£00.00</p>
								<p id="pPrice3">£00.00</p>
								<p id="pPrice4">£00.00</p>
							</div>
						</div>
						<div class="checkout-center-detail-payment">
							<div class="checkout-payment-payable-btn">
								<a (click)="add_to_cart()" id="addtocart" class="show">Add To Cart</a>
								<a routerLink="/buyticketcheckout" id="gototcart" class="hidden">Go To Cart</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="want-to-buy-season-tickets-section cf">
				<div class="want-to-buy-season-tickets-left">
					<h3>Want to buy Season Tickets?</h3>
				</div>
				<div class="want-to-buy-season-tickets-right">
					<div class="want-to-buy-season-tickets-right-image">
						<img src="assets/images/season-ic.png">
					</div>
				</div>
			</div>
		</div>
	</div>
</section><!-- page ends-->